module.exports = __webpack_public_path__ + "img/small-cards.ea108c97.png";